import { Scaling } from "./Scaling";
import { GameManager } from "../Managers/GameManager";
import { Communication } from "neo-games";
import { DataManager } from "../Managers/DataManager";

/**
 * @class CustomUtils
 * @author Marek Turkovic
 * 25.10.2019
 * todo Implement not only on baseResponse, but freespinsRespons etc..
 */
export class CustomUtils {
    public static hasRetrigger(): boolean {
        if (!CustomUtils.isLastFreespin()) {
            if (
                GameManager.freespinsResponse != null &&
                GameManager.freespinsResponse.wins != null &&
                GameManager.freespinsResponse.wins.length > 0
            ) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    public static isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/